module.exports = __webpack_public_path__ + "img/foodcheck_anime.074b6116.png";